import { browserLibraryRecovery, unreadableLibraryGames, useGameLibrary } from './gameLibrary';

/**
 * Shown where browser games are selected or edited; recovery never rewrites the stored data. It
 * also says when games from the account library were left out, which this version cannot read.
 */
export function BrowserLibraryNotice() {
  useGameLibrary();
  const recovery = browserLibraryRecovery();
  const leftOut = unreadableLibraryGames();
  if (!recovery.notice && leftOut === 0) return null;
  return (
    <div className="hint" role="status">
      {leftOut > 0 && (
        <p data-testid="library-left-out">
          {leftOut === 1
            ? 'A game in the online library could not be loaded by this version and is left out.'
            : `${leftOut} games in the online library could not be loaded by this version and are left out.`}
        </p>
      )}
      {recovery.notice && <p>{recovery.notice}</p>}
      {recovery.raw !== null && (
        <button
          onClick={() => {
            const url = URL.createObjectURL(
              new Blob([recovery.raw!], { type: 'application/json' }),
            );
            const link = document.createElement('a');
            link.href = url;
            link.download = 'rpg-arena-browser-library-backup.json';
            link.click();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
          }}
        >
          Download browser library backup
        </button>
      )}
    </div>
  );
}
